import { apiFetch } from "./api";
import { ClientListResponse } from "../types/fyo";

export interface ClientFilters {
  name?:              string;
  industry_vertical?: string;
  client_owner?:      string;
  no_linkedin?:       boolean;
  limit?:             number;
  offset?:            number;
}

export function fetchClients(filters: ClientFilters = {}): Promise<ClientListResponse> {
  const q = new URLSearchParams();
  if (filters.name)              q.set("name",              filters.name);
  if (filters.industry_vertical) q.set("industry_vertical", filters.industry_vertical);
  if (filters.client_owner)      q.set("client_owner",      filters.client_owner);
  if (filters.no_linkedin)       q.set("no_linkedin",       "true");
  q.set("limit",  String(filters.limit  ?? 50));
  q.set("offset", String(filters.offset ?? 0));
  return apiFetch(`/clients?${q}`);
}

export function patchClientLinkedin(rmsClientId: number, linkedinCompanyUrl: string): Promise<any> {
  return apiFetch(`/clients/${rmsClientId}/linkedin`, {
    method: "PATCH",
    body:   JSON.stringify({ linkedin_company_url: linkedinCompanyUrl }),
  });
}
